import script from "./studentCard.vue?vue&type=script&lang=js"
export * from "./studentCard.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__